import Authorize from "components/Authorize";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import { useGetTenantsQuery } from "../tenantSlice";
import CreateTenant from "../CreateTenant/CreateTenant";
import { Button, Grid, Paper } from "@material-ui/core";
import { tenantListStyles } from "./style";
import ResetPasswordDialog from "../../users/UserManagement/UserDialogs/resetPassword/resetPasswordDialog";
import { useState } from "react";
import TenantConfigDialog from "../TenantView/TenantConfigDialog";
const TenantList = ({ }) => {
    const classes = tenantListStyles();
    let { data: tenants, error, isLoading } = useGetTenantsQuery();

    return (<Authorize profile={permissionProfiles.SAAS_MANAGEMENT.MANAGE_TENANTS}>
        <Grid container direction='column' spacing={2} className={classes.tenantList}>
            <Grid item container direction="row" alignItems="center" justifyContent="space-between" className={classes.pageTitle}>
                <Grid item className={classes.pageTitle}>Tenants</Grid>
                <Grid item><CreateTenant /></Grid>
            </Grid>
            <>
                {tenants?.map((tenant, index) => <Grid item> <Tenant key={index} tenant={tenant} /></Grid>)}
            </>
        </Grid >
    </Authorize >)
}
export default TenantList;

const Tenant = ({ tenant }) => {
    const classes = tenantListStyles();
    const [openResetDialog, setOpenResetDialog] = useState(false);
    const onClickReset = () => {
        setOpenResetDialog(true)
    }

    return (
        <Paper className={classes.tenantCard}>
            <Grid container justifyContent="space-between" alignItems="center">
                <Grid item>
                    <div><b>{tenant.name}</b></div>
                    <div>
                        Support user name: {tenant?.supportUser?.userName}
                        {tenant?.supportUser && <Button
                            className={classes.resetButton}
                            onClick={onClickReset}
                            color="primary"
                            variant="outlined"
                        >
                            Reset Password
                        </Button>}
                    </div>

                    <ResetPasswordDialog
                        open={openResetDialog}
                        setOpenDialog={setOpenResetDialog}
                        userId={tenant?.supportUser?.id}>

                    </ResetPasswordDialog>
                </Grid>
                <Grid item className={classes.tenantCardActions}>
                    <TenantConfigDialog id={tenant?.id} />
                </Grid>
            </Grid>
        </Paper>
    )
}